import _ from "lodash";

const examples = {
  time: 1660750813.235,
  $arguments: "id=t3_yw1dx6&dir=1&api_type=json",
  $device_id: "182a231fdd1c09-0b27ca77a82ebd-1b525635-4da900-182a231fdd2da7",
  $user_id: "support@freshpaint.io",
  $os: "Mac OS X",
  $browser: "Chrome",
  $browser_version: 104,
  $current_url: "https://yourwebsite.com/pages/target-page.html?param=value",
  $device_type: "Desktop",
  $host: "yourwebsite.com",
  $initial_referrer: "http://google.com?q=query",
  $initial_referring_domain: "google.com",
  $pathname: "/pages/target-page.html",
  $referrer: "http://google.com?q=query",
  $referring_domain: "google.com",
  $response: '{"data":{"uploadV2Events":{"ok":true,"errors":null}}}',
  $responseType: "json",
  $requestUrl: "https://gql.reddit.com",
  $screen_height: 1080,
  $screen_width: 1920,
  $title: "Home Page",
  utm_source: "newsletter",
  utm_medium: "email",
  utm_campaign: "insta-ad1",
  utm_content: "toplink",
  utm_term: "jordan-sneakers",
  $ip: "8.8.8.8",
  $pageview_id: "182a239735d1fb-08f5527f006d0b-1b525635-4da900-182a239735e1cc5",
  $session_id: "182a231fdd3597-0341e9ffa768f-1b525635-4da900-182a231fdd41b94",
  target_text: "Confirm Purchase",
  $el_attr__href: "https://yourhref.com",
  mp_lib: "web",
  // These are specifically React Native events.
  $screen_name: "<React screen name>",
  $screen_path: "<React screen path>",

  // Android/iOS screen events.
  $category: "iOS/Android screen event category",

  // This is only for group calls.
  $group_id: "182a239735d1fb-08f5527f006d0b-1b525635-4da900-182a239735e1cc5",

  token: "a72d487f-e1db-4809-b29b-783e3281be18",
  $user_agent:
    "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/119.0.0.0 Safari/537.36",
};

export const builtinPropNames = _.keys(examples);

export function getBuiltinPropExampleValue(builtinPropName) {
  const exampleValue = examples[builtinPropName];
  if (exampleValue) {
    return exampleValue;
  }
  return `<${builtinPropName}>`;
}
